"use strict";
(globalThis["webpackChunktvg_shopify_theme"] ||= []).push([[9536],{

/***/ 9860
(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* unused harmony export default */
/* harmony import */ var _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7809);


class ProductCardListController extends _hotwired_stimulus__WEBPACK_IMPORTED_MODULE_0__.Controller {
  static targets = [
    "scrollTrack",
    "controls",
    "prevButton",
    "nextButton",
    "scrollbarTrack",
    "scrollbarThumb",
    "card",
  ];

  connect() {
    this.boundOnScroll = this.handleScroll.bind(this);
    this.scrollTrackTarget.addEventListener("scroll", this.boundOnScroll, {
      passive: true,
    });

    this.resizeObserver = new ResizeObserver(() => {
      this.equalizeCardHeights();
      this.updateOverflowState();
      this.updateScrollbar();
    });
    this.resizeObserver.observe(this.scrollTrackTarget);

    this.equalizeCardHeights();
    this.updateOverflowState();
  }

  disconnect() {
    this.resizeObserver?.disconnect();
    this.scrollTrackTarget.removeEventListener("scroll", this.boundOnScroll);
  }

  nextPage() {
    this.scrollTrackTarget.scrollBy({
      left: this.pageSize(),
      behavior: "smooth",
    });
  }

  previousPage() {
    this.scrollTrackTarget.scrollBy({
      left: -this.pageSize(),
      behavior: "smooth",
    });
  }

  handleScroll() {
    this.updateScrollbar();
  }

  updateOverflowState() {
    const { scrollWidth, clientWidth } = this.scrollTrackTarget;
    const hasOverflow = scrollWidth > clientWidth;

    this.controlsTarget.classList.toggle("hidden", !hasOverflow);
    this.controlsTarget.classList.toggle("flex", hasOverflow);

    if (hasOverflow) {
      this.updateScrollbar();
    }
  }

  updateScrollbar() {
    const { scrollWidth, clientWidth, scrollLeft } = this.scrollTrackTarget;
    if (scrollWidth <= clientWidth) return;

    const trackWidth = this.scrollbarTrackTarget.clientWidth;
    const thumbRatio = clientWidth / scrollWidth;
    const thumbWidth = Math.max(thumbRatio * trackWidth, 40);
    const maxThumbLeft = trackWidth - thumbWidth;
    const scrollRatio = scrollLeft / (scrollWidth - clientWidth);
    const thumbLeft = scrollRatio * maxThumbLeft;

    this.scrollbarThumbTarget.style.width = `${thumbWidth}px`;
    this.scrollbarThumbTarget.style.left = `${thumbLeft}px`;
  }

  equalizeCardHeights() {
    if (!this.hasCardTarget) return;

    // Reset heights to auto to get natural heights
    this.cardTargets.forEach((card) => {
      card.style.height = "auto";
    });

    // Find the tallest card
    const maxHeight = Math.max(
      ...this.cardTargets.map((card) => card.offsetHeight)
    );

    // Set all cards to the max height
    this.cardTargets.forEach((card) => {
      card.style.height = `${maxHeight}px`;
    });
  }

  pageSize() {
    const firstChild = this.scrollTrackTarget.querySelector(
      "[data-byo-target='productCategory']"
    );
    if (!firstChild?.firstElementChild) return this.scrollTrackTarget.clientWidth;

    return firstChild.firstElementChild.clientWidth;
  }
}

Stimulus.register("product-card-list", ProductCardListController);


/***/ }

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(9860)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);